import { apiClient } from './axiosConfig';
import {
  DeleteUserParamsProps,
  DeleteUserResponseProps,
  GetUserContactsParamsProps,
  GetUserContactsResponseProps,
  SaveUserContactsParamsProps,
  SaveUserContactsResponseProps,
  SaveUserParamsProps,
  SaveUserResponseProps,
} from './types';

export const getUserContactsApi = async (data: GetUserContactsParamsProps) => {
  const response = await apiClient.post<GetUserContactsResponseProps>('api/ownerappservice/AppGetUserContacts', {
    ...data,
  });

  return response.data;
};

export const saveUserContactsApi = async (data: SaveUserContactsParamsProps) => {
  const response = await apiClient.post<SaveUserContactsResponseProps>('api/ownerappservice/AppSaveUserContacts', {
    ...data,
  });

  return response.data;
};

export const saveUserApi = async (data: SaveUserParamsProps) => {
  const response = await apiClient.post<SaveUserResponseProps>('api/ownerappservice/AppSaveUser', {
    ...data,
  });

  return response.data;
};
